
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy/learn-smart-contract",
      function () {
        return require("private-next-pages/academy/learn-smart-contract/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/academy/learn-smart-contract"])
      });
    }
  